<template>
  <div class="route-index">
    <header-component/>
    <div class="main" :style="{ height }">
      <browser-detect v-if="show" v-model="show"/>
      <Sidebar/>
      <force-pwd-form v-if="is_default_password" @close="is_default_password = false"/>
      <user-center/>
      <div class="route-view scrollbar">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ElementUI from 'element-ui'
import { i18n } from '@/main'
import '@/common/styles/element-variables.scss'
import HeaderComponent from './Header'
import Sidebar from './Sidebar'
import BrowserDetect from './BrowserDetect'
import ForcePwdForm from './ForcePwdForm'
import UserCenter from './UserCenter'
Vue.use(ElementUI, { size: 'small', i18n: (key, value) => i18n.t(key, value) })
export default {
  components: {
    HeaderComponent,
    Sidebar,
    BrowserDetect,
    ForcePwdForm,
    UserCenter
  },
  data() {
    return {
      show: false,
      height: '800px'
    }
  },
  methods: {
    setMainHeight() {
      this.height = innerHeight - 60 + 'px'
    }
  },
  computed: {
    hideNav() {
      return this.$route.meta.hideNav
    },
    is_default_password: {
      get() {
        return this.$store.state.user.is_default_password
      },
      set(is_default_password) {
        this.$store.commit('setState', {
          module: 'user',
          key: 'is_default_password',
          value: is_default_password
        })
      }
    }

  },
  mounted() {
    this.$store.dispatch('getZoneSelf')
    const u = navigator.userAgent
    this.show = u.indexOf('Trident') > -1 || u.indexOf('Edge') > -1 || u.indexOf('QQ') > -1
    this.setMainHeight()
  }
}
</script>

<style scoped lang="scss">
.bottom-bar {
  text-align: center;
  font-size: 12px;
  display: block;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-left: 200px;
  background: #f8fffd;
}
.route-view {
  padding: 20px 20px;
  flex: 1;
  max-width: calc(100% -200px);
  overflow: auto;
  background: #f8fffd;
}
.route-index {
  overflow: hidden;
  height: 100%;
  width: 100%;
}
.main {
  display: flex;
  overflow-y: hidden;
  height: calc(100% - 82px);
  width: 100%;
}
</style>
